import React from "react";
import PropTypes from 'prop-types';

import Icon from "@material-ui/core/Icon";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import {withStyles} from "@material-ui/core";
import List from "@material-ui/core/List";
import i18n from "../../i18n";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import PreviewButton from "./PreviewButton";

const renderDetailsRow = (label, value, classes) => {
    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={6}>
                    <ListItemText primary={label} className={classes.detailsLabel}/>
                </Grid>
                <Grid item xs={6}>
                    <ListItemText primary={value} className={classes.detailsValue}/>
                </Grid>
            </Grid>
        </ListItem>
    );
};

const renderDownload = (file, classes) => {
    if (file && file.sRoute) {
        return (
            <a href={file.sRoute} className={classes.downloadButton}>
                <Button variant="contained" color="primary" className={classes.downloadButton}>
                    <Icon className={classes.iconSpace}>cloud_download</Icon>
                    Download
                </Button>
            </a>
        );
    }
    return null;
};

/** @namespace file.aRelations */
/** @namespace file.iCreated */
/** @namespace file.iId */
/** @namespace file.icon */
/** @namespace file.isDeleted */
/** @namespace file.isImage */
/** @namespace file.isNew */
/** @namespace file.oCreator */
/** @namespace file.sCreated */
/** @namespace file.sExt */
/** @namespace file.sFullPic */
/** @namespace file.sHash */
/** @namespace file.sMcePic */
/** @namespace file.sMime */
/** @namespace file.sName */
/** @namespace file.sPrevPic */
/** @namespace file.sRoute */
/** @namespace file.sRouteDelete */
/** @namespace file.sTags */
const FileCard = ({file, classes, className}) => (
    <Card className={className}>
        <CardHeader
            action={renderDownload()}
            title={file.sName || file.name || '-'}
            subheader={i18n.get('file.details.uploaded') + ': ' + file.sCreated}
        />
        {file.sPrevPic ? (
            <div className={classes.imageBlock}>
                <PreviewButton
                    file={file}
                    className={classes.preview}
                />
            </div>
        ) : file.icon && (
            <CardMedia
                className={classes.fileiconIcon}
                // image={"https://picsum.photos/200/300"}
                image={"/images/filetype/" + file.icon + ".svg"}
                title=""
            />
        )}
        <CardContent>
            <List>
                {renderDetailsRow(i18n.get('file.details.uploadedBy'), file.oCreator ? file.oCreator.name : '-', classes)}
                {renderDetailsRow(i18n.get('file.details.relations'), (
                    file.aRelations ? (
                        file.aRelations.length > 0 ? file.aRelations.map((rel, idx) => (
                                <span key={idx}>{(idx !== 0 ? ', ' : '') + (rel.name || '')}</span>
                            )
                        ) : '-'
                    ) : '-'
                ), classes)}
            </List>
            <CardActions>
                {renderDownload(file, classes)}
            </CardActions>
        </CardContent>
    </Card>
);

// Card.propTypes = {
//     classes: PropTypes.string.isRequired,
//     file: PropTypes.object.isRequired,
// };

const styles = theme => ({
    imageBlock: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "center",
        alignItems: "center",
    },
    preview: {
        height: 80,
        width: "auto",
    },
    fileiconIcon: {
        height: 80,
        "background-size": "inherit",
    },
    downloadButton: {
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        margin: "0 30px 0 0",
        "&:last-child": {
            padding: 0,
        }
    },
    detailsLabel: {
        textAlign: "right",
    },
    detailsValue: {
        "& > *": {
            ...theme.helpers.oneLiner,
        }
    },
    detailsRow: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    iconSpace: {
        marginRight: theme.spacing.unit * 0.5,
        marginLeft: theme.spacing.unit * 0.5,
    },
});

export default withStyles(styles)(FileCard);



// WEBPACK FOOTER //
// ./resources/assets/js/components/File/Card.jsx